/* MeshSurfaceSampler — order-safe, CMS-safe, CDN-safe */
(function () {
  function attachSampler() {
    if (!window.THREE) return false;
    if (THREE.MeshSurfaceSampler) return true; // already attached

    const { Triangle, Vector3 } = THREE;

    function binarySearch(array, value) {
      let start = 0;
      let end = array.length - 1;
      while (start <= end) {
        const mid = (start + end) >> 1;
        if (array[mid] > value) end = mid - 1;
        else start = mid + 1;
      }
      return start;
    }

    class MeshSurfaceSampler {
      constructor(mesh) {
        this.mesh = mesh;
        this.geometry = mesh.geometry;
        this.distribution = null;
        this.totalArea = 0;
      }

      build() {
        const geom = this.geometry;
        const pos = geom.attributes.position;
        const idx = geom.index;

        const tri = new Triangle();
        const a = new Vector3();
        const b = new Vector3();
        const c = new Vector3();

        const triCount = idx ? idx.count / 3 : pos.count / 3;
        this.distribution = new Float32Array(triCount);

        let areaSum = 0;

        for (let i = 0; i < triCount; i++) {
          if (idx) {
            a.fromBufferAttribute(pos, idx.getX(i * 3));
            b.fromBufferAttribute(pos, idx.getX(i * 3 + 1));
            c.fromBufferAttribute(pos, idx.getX(i * 3 + 2));
          } else {
            a.fromBufferAttribute(pos, i * 3);
            b.fromBufferAttribute(pos, i * 3 + 1);
            c.fromBufferAttribute(pos, i * 3 + 2);
          }

          tri.set(a, b, c);
          areaSum += tri.getArea();
          this.distribution[i] = areaSum;
        }

        this.totalArea = areaSum;
        return this;
      }

      sample(target) {
        const r = Math.random() * this.totalArea;
        const faceIndex = binarySearch(this.distribution, r);

        const pos = this.geometry.attributes.position;
        const idx = this.geometry.index;

        const a = new Vector3();
        const b = new Vector3();
        const c = new Vector3();

        if (idx) {
          a.fromBufferAttribute(pos, idx.getX(faceIndex * 3));
          b.fromBufferAttribute(pos, idx.getX(faceIndex * 3 + 1));
          c.fromBufferAttribute(pos, idx.getX(faceIndex * 3 + 2));
        } else {
          a.fromBufferAttribute(pos, faceIndex * 3);
          b.fromBufferAttribute(pos, faceIndex * 3 + 1);
          c.fromBufferAttribute(pos, faceIndex * 3 + 2);
        }

        let u = Math.random();
        let v = Math.random();
        if (u + v > 1) {
          u = 1 - u;
          v = 1 - v;
        }

        target
          .copy(a)
          .multiplyScalar(1 - u - v)
          .add(b.multiplyScalar(u))
          .add(c.multiplyScalar(v));

        return target;
      }
    }

    THREE.MeshSurfaceSampler = MeshSurfaceSampler;
    return true;
  }

  // Try immediately
  if (attachSampler()) return;

  // Otherwise wait until THREE exists
  const timer = setInterval(() => {
    if (attachSampler()) clearInterval(timer);
  }, 16);
})();
